import {AVariableContext} from '../../../enums';

export class AVariableReq {
    value!: string;
}
export enum VVariableMutabilityType {
    ReadOnly = 0,
    WriteOnly = 1,
    ReadAndWrite = 2,
}

export class AVariableRes {
    id!: number;
    name!: string;
    value!: string;
    mutability!: VVariableMutabilityType;
    mutabilityName!: string;
    contextName!: string;
    context!: AVariableContext;
    type!: string;
}